type Args = {
  filters: GQL_SearchFilters
  /** The map is zoomed out past any one market's reach */
  zoomedOutPastMarkets: boolean
  resultsCount: number
  loading: boolean
}

// A free-roaming map (dragged away from any market search) should offer the
// markets as wayfinding instead of listing pins. Gate on the zoom the
// visitor is looking at: a fresh load mounts at a default zoom without ever
// fitting the map to the URL's bounds, so those bounds say nothing about
// what is on screen.
const shouldShowMarketCities = ({
  filters,
  zoomedOutPastMarkets,
  resultsCount,
  loading,
}: Args): boolean => {
  const { country, state, sw, ne } = filters
  const boundsOnly = !country && !state && sw != null && ne != null
  if (!boundsOnly) {
    return false
  }

  return zoomedOutPastMarkets || (!loading && resultsCount === 0)
}

export default shouldShowMarketCities
